import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { EmailsPageStateService } from '@app-services/emails/emails-page-state.service';

@Component({
  selector: 'app-email-select-checkbox',
  templateUrl: './email-select-checkbox.component.html',
  styleUrls: ['./email-select-checkbox.component.scss'],
  imports: [TranslateModule, MatCheckbox],
})
export class EmailSelectCheckboxComponent {
  @Input() emailId: number;

  constructor(protected emailsPageStateService: EmailsPageStateService) {}
}
